import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-date-render',
  templateUrl: './date-render.component.html',
  styleUrls: ['./date-render.component.css']
})
export class DateRenderComponent implements OnInit {

  @Input() date;
  @Input() format;

  constructor() { }

  ngOnInit(): void {

  }

  /*  console.log(this.date.toLocaleDateString("en-US")); */ // 9/17/2016
  /* console.log(this.date.toLocaleDateString("en-US", options)); */ // Saturday, September 17, 2016
  getDate(){
    let buff;
    let options;
    if(this.format === 'long'){
      options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    }
    if(this.format === 'short'){
      options = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'};
    }
    if(this.format === 'tiny'){
      options = { weekday: 'short', day: 'numeric', month: 'short'};
    }
    this.date  = new Date(this.date);
    buff = this.date.toLocaleDateString("es-ES", options);
    buff == 'Invalid Date'? buff = '': null;
    return buff;
  }

}
